import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, Alert, Row, Col } from "antd";
import "antd/dist/antd.css";

type HeaderProps = {
  text: String;
};

function HeaderModalText(props: HeaderProps) {
  const { text } = props;

  return <text className="header_modal_text">{text}</text>;
}

export default HeaderModalText;
